import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import API_BASE from '../config';

// Static fallback content (mirrors BlogPage's STATIC_POSTS)
const STATIC_POSTS = [
    {
        id: 1, slug: 'top-interior-design-trends-2025',
        title: 'Top Interior Design Trends to Watch in 2025',
        excerpt: 'From biophilic design to earthy palettes and multifunctional furniture — here are the design trends that will define homes in 2025.',
        featured_image: 'https://images.unsplash.com/photo-1618219944342-824e40a13285?w=1200&q=85',
        author: 'Priya Sharma', category: 'Design Trends', published_at: '2025-02-15',
        content: `<p style="margin-bottom:1rem;line-height:1.8">The interior design world is constantly evolving, and 2025 promises to be a year of bold experimentation balanced with a deep desire for comfort and sustainability.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">1. Biophilic Design</h3><p style="margin-bottom:1rem;line-height:1.8">Bringing nature indoors continues to grow stronger. Expect to see more indoor plants, natural materials like rattan, stone, and raw wood, and rooms designed to maximise natural light.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">2. Earthy, Grounded Palettes</h3><p style="margin-bottom:1rem;line-height:1.8">Neutrals are evolving beyond beige. Terracottas, warm ochres, olive greens, and deep burgundy tones are creating rooms that feel grounded and timeless.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">3. Multifunctional Spaces</h3><p style="margin-bottom:1rem;line-height:1.8">As hybrid work continues, rooms that serve double-duty — a guest room that doubles as a home office — are in high demand.</p>`,
    },
    {
        id: 2, slug: 'modular-kitchen-guide-india',
        title: 'The Complete Guide to Modular Kitchens in India',
        excerpt: 'Everything you need to know about modular kitchen materials, layouts, costs, and how to choose the right design for your home.',
        featured_image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=85',
        author: 'Ravi Teja', category: 'Modular Kitchen', published_at: '2025-01-28',
        content: `<p style="margin-bottom:1rem;line-height:1.8">A modular kitchen is the most significant investment in your kitchen renovation. Getting it right requires understanding materials and layouts.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">Choosing the Right Layout</h3><p style="margin-bottom:1rem;line-height:1.8">L-shaped kitchens work well for medium spaces, U-shaped for larger kitchens, and straight-line kitchens are ideal for compact apartments.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">Material Selection</h3><p style="margin-bottom:1rem;line-height:1.8">MDF, Plywood, and HDHMR are the go-to cabinet materials. For shutters, choose between laminates, acrylic or lacquered glass finishes. Always use kitchen-grade plywood for the base structure.</p>`,
    },
    {
        id: 3, slug: 'false-ceiling-designs-2025',
        title: 'False Ceiling Design Ideas That Will Transform Your Home',
        excerpt: 'False ceilings are no longer just functional — they are a design statement.',
        featured_image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1200&q=85',
        author: 'Suresh Kumar', category: 'Design Ideas', published_at: '2025-01-10',
        content: `<p style="margin-bottom:1rem;line-height:1.8">A false ceiling can completely transform a room. It adds visual height, hides electrical wiring, and creates zones for different types of lighting.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">POP vs Gypsum</h3><p style="margin-bottom:1rem;line-height:1.8">POP (Plaster of Paris) is more affordable and allows custom shapes but takes longer to install. Gypsum boards can be installed faster and are better for straight, geometric designs.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">Cove Lighting</h3><p style="margin-bottom:1rem;line-height:1.8">Indirect cove lighting hidden within a false ceiling recess creates a warm, ambient glow that makes any room feel luxurious.</p>`,
    },
    {
        id: 4, slug: 'south-india-interior-design-cost-guide',
        title: 'Interior Design Cost Guide for Homes in South India (2025)',
        excerpt: 'How much does a complete home interior cost?',
        featured_image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&q=85',
        author: 'Priya Sharma', category: 'Budget & Cost', published_at: '2024-12-20',
        content: `<p style="margin-bottom:1rem;line-height:1.8">One of the most common questions is "How much will interior design cost?" Here are realistic figures based on our 350+ projects across South India.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">2BHK Interior Design Cost</h3><p style="margin-bottom:1rem;line-height:1.8">A complete 2BHK interior typically costs between ₹8–14 lakhs depending on material quality.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">3BHK Interior Design Cost</h3><p style="margin-bottom:1rem;line-height:1.8">A complete 3BHK ranges from ₹12–22 lakhs. The key variable is material quality and design complexity.</p>`,
    },
    {
        id: 5, slug: 'wardrobe-design-tips',
        title: '10 Wardrobe Design Tips to Maximise Your Storage',
        excerpt: 'Smart wardrobe organisation tips and design ideas.',
        featured_image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=85',
        author: 'Ravi Teja', category: 'Bedroom Design', published_at: '2024-12-05',
        content: `<p style="margin-bottom:1rem;line-height:1.8">A well-designed wardrobe is the backbone of an organised bedroom.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">1. Measure Your Clothes First</h3><p style="margin-bottom:1rem;line-height:1.8">Before designing, take stock of how many hanging items, folded items, and shoes you own.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">2. Sliding vs Hinged Doors</h3><p style="margin-bottom:1rem;line-height:1.8">Sliding doors are better for smaller rooms as they don't require clearance space to open.</p>`,
    },
    {
        id: 6, slug: 'vastu-interior-design',
        title: 'Vastu Shastra & Modern Interior Design — Finding the Balance',
        excerpt: 'How Bliv Design Studio integrates Vastu principles into contemporary home design.',
        featured_image: 'https://images.unsplash.com/photo-1600607688969-a5bfcd646154?w=1200&q=85',
        author: 'Suresh Kumar', category: 'Design Philosophy', published_at: '2024-11-18',
        content: `<p style="margin-bottom:1rem;line-height:1.8">Vastu Shastra is an ancient Indian system of architecture that aligns living spaces with natural forces.</p><h3 style="font-size:1.25rem;font-weight:700;margin:1.5rem 0 0.5rem">Vastu for the Kitchen</h3><p style="margin-bottom:1rem;line-height:1.8">Vastu recommends the kitchen in the South-East direction. The cooking platform should face East. We integrate these principles through thoughtful layout planning.</p>`,
    },
];

export default function BlogDetailPage() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [related, setRelated] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        // Try API first, fall back to static
        fetch(`${API_BASE}/blog.php?slug=${slug}`)
            .then(r => r.json())
            .then(data => {
                if (data?.post) {
                    setPost(data.post);
                    setRelated(data.related || []);
                } else throw new Error('Not found');
            })
            .catch(() => {
                const found = STATIC_POSTS.find(p => p.slug === slug);
                if (found) {
                    setPost(found);
                    setRelated(STATIC_POSTS.filter(p => p.id !== found.id).slice(0, 3));
                }
            })
            .finally(() => setLoading(false));
    }, [slug]);

    useEffect(() => {
        if (post) {
            const title = `${post.title} | Bliv Design Studio Blog`;
            const description = post.excerpt || 'Interior design article by Bliv Design Studio.';
            document.title = title;
            
            let meta = document.querySelector('meta[name="description"]');
            if (!meta) {
                meta = document.createElement('meta');
                meta.name = 'description';
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', description);
        }
    }, [post]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center pt-32">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-[#2E63E8] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                    <p className="text-gray-500">Loading article…</p>
                </div>
            </div>
        );
    }

    if (!post) {
        return (
            <div className="min-h-screen flex items-center justify-center pt-32 text-center px-4">
                <div>
                    <p className="text-6xl mb-4">📄</p>
                    <h2 className="text-2xl font-bold text-gray-900 mb-3">Article Not Found</h2>
                    <p className="text-gray-500 mb-6">This blog post may have been moved or deleted.</p>
                    <Link to="/blog" className="btn-yellow inline-block px-8 py-3">← Back to Blog</Link>
                </div>
            </div>
        );
    }

    const date = new Date(post.published_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

    return (
        <>
            {/* Hero */}
            <section className="relative pt-32 h-[60vh] min-h-[400px] flex items-end">
                <div className="absolute inset-0">
                    <img src={post.featured_image} alt={post.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/10" />
                </div>
                <div className="relative max-w-4xl mx-auto px-4 pb-10 w-full">
                    <span className="inline-block bg-[#2E63E8] text-white text-xs font-bold px-4 py-1.5 rounded-full mb-4">{post.category}</span>
                    <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-4">{post.title}</h1>
                    <div className="flex items-center gap-4 text-gray-300 text-sm">
                        <span>By {post.author}</span>
                        <span>·</span>
                        <span>{date}</span>
                    </div>
                </div>
            </section>

            {/* Content */}
            <section className="section-pad bg-white">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
                        {/* Article */}
                        <div className="lg:col-span-2">
                            <Link to="/blog" className="inline-flex items-center gap-1 text-[#2E63E8] text-sm font-semibold mb-8 hover:gap-2 transition-all">
                                ← Back to Blog
                            </Link>
                            <div
                                className="prose prose-gray max-w-none text-gray-700"
                                dangerouslySetInnerHTML={{ __html: post.content }}
                            />

                            {/* Share */}
                            <div className="mt-10 pt-8 border-t border-gray-100">
                                <p className="text-gray-500 text-sm font-semibold mb-3">Share this article:</p>
                                <div className="flex gap-3">
                                    {['WhatsApp', 'Facebook', 'Twitter'].map(s => (
                                        <a key={s} href="#" className="bg-gray-100 hover:bg-[#2E63E8] hover:text-white text-gray-700 text-xs font-bold px-4 py-2 rounded-full transition-all">
                                            {s}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div>
                            {/* CTA Card */}
                            <div className="bg-[#0D0D0D] rounded-2xl p-6 text-white mb-6 sticky top-32">
                                <h3 className="font-bold text-lg mb-3">Ready to Transform Your Home?</h3>
                                <p className="text-gray-400 text-sm mb-5">Get a free design consultation with our expert team.</p>
                                <a href="/contact" className="btn-yellow w-full block text-center text-sm py-3">
                                    Book Free Consultation
                                </a>
                            </div>

                            {/* Related posts */}
                            {related.length > 0 && (
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-4">Related Articles</h3>
                                    <div className="space-y-4">
                                        {related.map(r => (
                                            <Link key={r.id} to={`/blog/${r.slug}`} className="flex gap-3 group rounded-xl p-2 hover:bg-gray-50 transition-colors">
                                                <img src={r.featured_image} alt={r.title} className="w-20 h-16 rounded-lg object-cover flex-shrink-0" />
                                                <div>
                                                    <p className="text-gray-800 font-semibold text-sm group-hover:text-[#2E63E8] transition-colors leading-snug line-clamp-2">{r.title}</p>
                                                    <p className="text-gray-400 text-xs mt-1">{r.author}</p>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
